import API from "../../utils/api";

export const getProductsApi = async (data) => {
  const response = await API.get(`product`, {
    params: data,
  });
  return { response };
};
export const getProductSetting = async (data) => {
  const response = await API.get(`product/get-product-settings`, {
    params: data,
  });
  return { response };
};

export const getProductCreateSetting = async (data) => {
  const response = await API.get(`product/get-product-create-settings`, {
    params: data,
  });
  return { response };
};

export const addProductApi = async (data) => {
  const response = await API.post("product", data);
  return { response };
};

export const getProductApi = async (id) => {
  const response = await API.get(`product/` + id + "/edit");
  return { response };
};
export const getProductViewApi = async (id) => {
  const response = await API.get(`product/` + id);
  return { response };
};
export const getAIProductViewApi = async (id) => {
  const response = await API.get(`product/${id}/ai-details`);
  return { response };
};
export const getAiTagsBasedOnImageApi = async (data) => {
  const response = await API.get(`product/ai-tags/fetch/${data.product_id}`, {
    params: data,
  });
  return { response };
};
export const getDraftAiProductApi = async (id) => {
  const response = await API.get(`product/draft_ai/fetch/${id}`);
  return { response };
};
export const getAiFromCGPortalApi = async (data) => {
  const response = await API.get(`product/ai-cg-portal/fetch/${data.product_id}`, {
    params: data,
  });
  return { response };
};
export const updateAIProductDetailsApi = async (data, id) => {
  const response = await API.put(`product/${id}/ai-details/update`, data);
  return { response };
};
export const updateProductApi = async (data, id) => {
  const response = await API.put(`product/${id}`, data);
  return { response };
};
export const getCategoryByTypeId = async (id) => {
  const response = await API.get(`product/get-category/` + id);
  return { response };
};
export const getSubCategoryByCategoryId = async (id) => {
  const response = await API.get(`product/get-sub-category/` + id);
  return { response };
};
export const addProductImageApi = async (id, data) => {
  const response = await API.post("product/upload-image/" + id, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const deleteProductApi = async (id) => {
  const response = await API.delete(`product/delete-image/${id}`);
  return { response };
};

export const uploadSizeColourImageApi = async (productId, data) => {
  const response = await API.post("product/size-colour-media/" + productId + "/image", data, { "content-type": "multipart/form-data" });
  return { response };
};

export const uploadSizeColourVideoApi = async (productId, data) => {
  const response = await API.post("product/size-colour-media/" + productId + "/video", data, { "content-type": "multipart/form-data" });
  return { response };
};

export const deleteSizeColourMediaApi = async (id) => {
  const response = await API.delete("product/size-colour-media/" + id);
  return { response };
};

export const deleteSizeColourVideoApi = async (id) => {
  const response = await API.delete("product/size-colour-media/" + id + "/video");
  return { response };
};

export const getSizeColourMediaApi = async (productId) => {
  const response = await API.get("product/size-colour-media/" + productId);
  return { response };
};

export const getFitModelsApi = async () => {
  const response = await API.get("settings/fit-model");
  return { response };
};

export const assignSizeColourFitModelApi = async (id, data) => {
  const response = await API.put("product/size-colour-media/" + id + "/fit-model", data);
  return { response };
};

export const sortProductImageApi = async (id, data) => {
  const response = await API.post("product/sort-image/" + id, data);
  return { response };
};

// Set exactly these partners on these images (empty partner_ids = normal Goddiva images).
export const setImagePartnersApi = async (productId, data) => {
  const response = await API.post(`product/${productId}/image-partners`, data);
  return { response };
};

export const bulkProductApi = async (data) => {
  const response = await API.post("product/bulk-product-action", data);
  return { response };
};

export const bulkNewlyCreateAndPublishApi = async (data) => {
  const response = await API.post("product/newly-create-and-publish", data);
  return { response };
};

export const createDuplicateProductApi = async (data) => {
  const response = await API.post("product/create-duplicate-product", data);
  return { response };
};

export const bulkSalesOfferApi = async (data) => {
  const response = await API.post("product/bulk-sales-offer-update", data);
  return { response };
};

export const bulkAddProductTagsApi = async (data) => {
  const response = await API.post("product/bulk-add-tags", data);
  return { response };
};

export const bulkRemoveProductTagsApi = async (data) => {
  const response = await API.post("product/bulk-remove-tags", data);
  return { response };
};

export const updateProductImageAltTextApi = async (data) => {
  const response = await API.post("product/update-image-alt-text", data);
  return { response };
};
export const sellerAutoSuggestionApi = async (text) => {
  const response = await API.get("product/seller-auto-suggestion", {
    params: text,
  });
  return { response };
};

export const sellerBrandSuggestionApi = async (text) => {
  const response = await API.get("product/brand-auto-suggestion", {
    params: text,
  });
  return { response };
};
export const taxonomySuggestionApi = async (text) => {
  const response = await API.get("product/taxonomy-auto-suggestion", {
    params: text,
  });
  return { response };
};

export const addProductLookBookApi = async (data) => {
  const response = await API.post("product/look-book/store-product-look-book", data);
  return { response };
};

export const downloadLookBookApi = async (id) => {
  const response = await API.get(`product/look-book/product-look-book/${id}`, { "content-type": "application/pdf", responseType: "blob" });
  return { response };
};

export const checkLookBookTitleApi = async (data) => {
  const response = await API.get("product/look-book/check-look-book_title", {
    params: data,
  });
  return { response };
};

export const getLookBookApi = async (data) => {
  const response = await API.get(`product/look-book/look-book-view`, {
    params: data,
  });
  return { response };
};

export const getCurrencyRateApi = async (price, code) => {
  const response = await API.get(`product/look-book/currency-convert/${price}/${code}`);
  return { response };
};

export const getExportApi = async (data) => {
  const response = await API.get(
    `product/export-stockprice`,
    {
      params: data,
    },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const updateInventoryBulkApi = async (data) => {
  const response = await API.post("product/import-stockprice", data, { "content-type": "multipart/form-data" });
  return { response };
};
export const updateInventoryBulkBySkuApi = async (data) => {
  const response = await API.post("product/inventory/import-by-sku", data, { "content-type": "multipart/form-data", responseType: "json" });
  return { response };
};

export const addProductHolidayOfferApi = async (data) => {
  const response = await API.post("product/holiday-mode", data);
  return { response };
};

export const downloadSampleCsvApi = async () => {
  const response = await API.get("product/download/sample-csv", { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const importProductCsvApi = async (data) => {
  const response = await API.post(`product/import-products`, data);
  return { response };
};

export const importProductsTagsApi = async (data) => {
  const response = await API.post(`product/import-products-tags`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const importProductsGradeTagsApi = async (data) => {
  const response = await API.post(`product/import-grade-tags`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const createSentImageApi = async (data) => {
  const response = await API.post("product/send-image", data);
  return { response };
};

export const updateAddtionalApi = async (data, id) => {
  const response = await API.post(`product/additional-details/${id}`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const getAdditionalSettingsApi = async (id) => {
  const response = await API.get(`product/additional-details/${id}`);
  return { response };
};

export const getProductInfoApi = async (id) => {
  const response = await API.get(`product/get-draft-product/${id}`);
  return { response };
};

export const exportProductsApi = async (data) => {
  const response = await API.get(
    "product/export-usa-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportEUProductsApi = async (data) => {
  const response = await API.get(
    "product/export-eu-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportIndiaProductsApi = async (data) => {
  const response = await API.get(
    "product/export-india-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportMarketplaceProductsApi = async (data) => {
  const response = await API.get(
    "product/export-marketplace-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportWalmartProductsApi = async (data) => {
  const response = await API.get(
    "product/export-walmart-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportProductsToTBOneApi = async (data) => {
  const response = await API.get("tbone/product-export", { params: data }, { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const exportUSProductsApi = async (data) => {
  const response = await API.get("product/inventory-export", { params: data }, { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const exportLystFeedProductsApi = async (data) => {
  const response = await API.get("product/export-lyst-feed", { params: data });
  return { response };
};

export const exportGroupedProductsApi = async () => {
  const response = await API.get("product/export-group-product-report");
  return { response };
};

export const codeWithColourAutoSuggestion = async (data) => {
  const response = await API.get("product/code-with-colour-auto-suggestion", { params: data });
  return { response };
};

export const codeAutoSuggestion = async (data) => {
  const response = await API.get("product/code-auto-suggestion", { params: data });
  return { response };
};

export const codeWithMainWiseColourAutoSuggestion = async (data) => {
  const response = await API.get("product/looklab-main-colour-wise-auto-suggestion", { params: data });
  return { response };
};

export const variantColourWiseAutoSuggestion = async (data) => {
  const response = await API.get("product/variant-colour-wise-auto-suggestion", { params: data });
  return { response };
};

export const syncGTNNumberApi = async (data) => {
  const response = await API.post(`product/sync-gtn-numbers`, data);
  return { response };
};

export const getCheckHolidayOrdersApi = async (data) => {
  const response = await API.post(`seller-product/holiday-orders`, data);
  return { response };
};

export const exportActiveOrdersApi = async (data) => {
  const response = await API.post("product/export-active-orders", data, {
    responseType: 'blob'  
  });
  return { response };
};

export const getSizeQuantityApi = async (data) => {
  const response = await API.get(`product/mystery-product/qty` , { params: data });
  return { response };
};

export const getPriceReductionProductsApi = async (data) => {
  const response = await API.get("product/price-reductions", {
    params: data,
  });
  return { response };
};

export const exportPriceReductionStockApi = async (data) => {
  const response = await API.get("product/price-reductions/export", {
    params: data,
    responseType: 'blob',
    skipNotFoundRedirect: true,
  });
  return { response };
};

export const getDataQualityAlertsApi = async (data) => {
  const response = await API.get("product/data-quality-alerts", {
    params: data,
  });
  return { response };
};

export const exportDataQualityAlertsApi = async (data) => {
  const response = await API.get("product/data-quality-alerts/export", {
    params: data,
    responseType: 'blob',
    skipNotFoundRedirect: true,
  });
  return { response };
};

export const getPriceReductionFilterOptionsApi = async () => {
  const response = await API.get("product/price-reductions/filter-options");
  return { response };
};

export const getPriceReductionAiRecommendationApi = async (data) => {
  const response = await API.post("product/price-reductions/ai-recommendation", data);
  return { response };
};

export const getProductSalesByPriceApi = async (productId) => {
  const response = await API.get(`product/${productId}/performance/sales-by-price`);
  return { response };
};

export const getProductDiscountAnalysisApi = async (productId) => {
  const response = await API.post(`product/${productId}/performance/discount-analysis`);
  return { response };
};

export const storePriceReductionsApi = async (data) => {
  const response = await API.post("product/price-reductions/store", data);
  return { response };
};

export const getPriceReductionRequestsApi = async (data) => {
  const response = await API.get("product/price-reductions-requests", {
    params: data,
  });
  return { response };
};

export const getPriceReductionRequestFilterOptionsApi = async (data) => {
  const response = await API.get("product/price-reductions-requests/filter-options", {
    params: data,
  });
  return { response };
};

export const getPriceReductionRequestDetailsApi = async (id) => {
  const response = await API.get(`product/price-reductions-requests/${id}/details`);
  return { response };
};

export const approvePriceReductionRequestApi = async (id, data = {}) => {
  const response = await API.post(`product/price-reductions-requests/${id}/approve`, data);
  return { response };
};

export const declinePriceReductionRequestApi = async (id, data = {}) => {
  const response = await API.post(`product/price-reductions-requests/${id}/decline`, data);
  return { response };
};

export const getVariantMappingApi = async (id) => {
  const response = await API.get(`product/${id}/variant-mapping`);
  return { response };
};

// ---- Product Signature Details ----
// product_signature_details.product_id is keyed on the internal `products.id` (the same
// convention product_additional_details already uses via Product::additinalDetail()'s
// default hasOne), not the external Shopify product id — every function below still names
// the parameter `productId` for call-site clarity, but callers must pass products.id.
//
// `data` for add/update/toggleActive must be a FormData instance (media_file/thumbnail are
// file uploads); each function guarantees the scoped product_id is on the request itself
// rather than trusting the caller included it.

const withScopedProductId = (data, productId) => {
  data.delete("product_id");
  data.append("product_id", productId);
  return data;
};

export const getProductSignatureDetailsApi = async (productId) => {
  // Admin management list — unlike the embedded product-show payload, this includes
  // inactive rows too (ordered by display_order asc, then id asc).
  const response = await API.get("product-signature-details", {
    params: { product_id: productId },
  });
  return { response };
};

export const addProductSignatureDetailApi = async (productId, data) => {
  const response = await API.post("product-signature-details", withScopedProductId(data, productId), {
    "content-type": "multipart/form-data",
  });
  return { response };
};

export const updateProductSignatureDetailApi = async (id, productId, data) => {
  // The backend route is a real PUT, but PHP never populates $_FILES for a PUT body, so a
  // literal axios .put() with multipart data would silently drop media_file/thumbnail.
  // Send it as POST with Laravel's _method spoofing instead (same reasoning applies to
  // toggleActive below, which is just this same call with `status` flipped).
  data.delete("_method");
  data.append("_method", "PUT");
  const response = await API.post(`product-signature-details/${id}`, withScopedProductId(data, productId), {
    "content-type": "multipart/form-data",
  });
  return { response };
};

export const toggleProductSignatureDetailActiveApi = async (id, productId, data) => {
  // No dedicated toggle-active endpoint: UpdateProductSignatureDetailRequest requires the
  // full editable field set (product_id, title, media_type, ...) on every update, not a
  // partial patch, so this is a thin alias over update() — `data` must already contain the
  // record's current fields with `status` set to the new value.
  return updateProductSignatureDetailApi(id, productId, data);
};

export const deleteProductSignatureDetailApi = async (id) => {
  const response = await API.delete(`product-signature-details/${id}`);
  return { response };
};

// ---- How to Style Video ----
// products.how_to_style_video_url (Phase 1/2/3 backend) is keyed on the internal
// `products.id`, matching size-colour-media's convention — the route param is named
// {productId} but callers must pass products.id, not the Shopify id. The upload/delete
// responses return the raw product model (an unresolved storage path, not a URL); read
// the display-ready URL from the Product Details response instead (getProductViewApi /
// product/{id}, field `how_to_style_video_url`).

export const uploadHowToStyleVideoApi = async (productId, data) => {
  const response = await API.post(`product/how-to-style-video/${productId}`, data, {
    "content-type": "multipart/form-data",
  });
  return { response };
};

export const deleteHowToStyleVideoApi = async (productId) => {
  const response = await API.delete(`product/how-to-style-video/${productId}`);
  return { response };
};

export const reorderProductSignatureDetailsApi = async (productId, orderedIdsOrPositions) => {
  // Accepts either a plain array of ids (new order implied by array position) or an array
  // of already-built {id, display_order} pairs.
  const items = orderedIdsOrPositions.map((entry, index) =>
    entry && typeof entry === "object" ? { id: entry.id, display_order: entry.display_order } : { id: entry, display_order: index }
  );
  const response = await API.post("product-signature-details/reorder", {
    product_id: productId,
    items,
  });
  return { response };
};

// ---- Wear It To ----
// product_wear_it_tos.product_id: same convention confirmed by cardListing.jsx's actual
// callers of ManageSignatureDetailsModal (`productId={signatureDetailsProduct?.id}`) — the
// internal `products.id`, not the Shopify id, regardless of what the product_wear_it_tos
// migration's inline comment says.
//
// `data` for add/update must be a FormData instance (media_path is a file upload); each
// function guarantees the scoped product_id is on the request itself rather than trusting
// the caller included it.

const withScopedWearItToProductId = (data, productId) => {
  data.delete("product_id");
  data.append("product_id", productId);
  return data;
};

export const getProductWearItTosApi = async (productId) => {
  const response = await API.get("product-wear-it-tos", {
    params: { product_id: productId },
  });
  return { response };
};

export const addProductWearItToApi = async (productId, data) => {
  const response = await API.post("product-wear-it-tos", withScopedWearItToProductId(data, productId), {
    "content-type": "multipart/form-data",
  });
  return { response };
};

export const updateProductWearItToApi = async (id, productId, data) => {
  // Same PHP $_FILES-on-PUT limitation as updateProductSignatureDetailApi above: PHP never
  // populates $_FILES for a PUT request body, so a literal axios .put() with multipart data
  // would silently drop media_path on replacement. Send as POST with Laravel's _method
  // spoofing instead — the route stays a real PUT server-side.
  data.delete("_method");
  data.append("_method", "PUT");
  const response = await API.post(`product-wear-it-tos/${id}`, withScopedWearItToProductId(data, productId), {
    "content-type": "multipart/form-data",
  });
  return { response };
};

export const deleteProductWearItToApi = async (id) => {
  const response = await API.delete(`product-wear-it-tos/${id}`);
  return { response };
};

export const reorderProductWearItTosApi = async (productId, orderedIdsOrPositions) => {
  // Same shape as reorderProductSignatureDetailsApi: accepts either a plain array of ids
  // (new order implied by array position) or an array of already-built {id, display_order} pairs.
  const items = orderedIdsOrPositions.map((entry, index) =>
    entry && typeof entry === "object" ? { id: entry.id, display_order: entry.display_order } : { id: entry, display_order: index }
  );
  const response = await API.post("product-wear-it-tos/reorder", {
    product_id: productId,
    items,
  });
  return { response };
};

// ---- Fabric & Care ----
// product_fabric_cares.product_id is the internal products.id (route param {id} on both
// endpoints), same convention as Signature Details / Wear It To above. No file upload here
// (short description + two id arrays only), so a plain JSON body is sent, not multipart.
// Nested under product/fabric-care/{id} (not product-fabric-care/{id}) so that hyphenated
// path is free for the public feed, matching product-signature-details / product-wear-it-tos.

export const getProductFabricCareApi = async (productId) => {
  const response = await API.get(`product/fabric-care/${productId}`);
  return { response };
};

export const saveProductFabricCareApi = async (productId, data) => {
  const response = await API.post(`product/fabric-care/${productId}`, data);
  return { response };
};

// ---- Questions & Answers ----
// product_questions_answers.product_id is the internal products.id (query-string / body
// param on the admin routes below), same convention as Signature Details / Wear It To.
// No file upload here (question + answer text only), so plain JSON bodies are sent, not
// multipart — same convention as Fabric & Care above. Every entry belongs to a
// qa_category_id (see settings/qaCategoryService.jsx for managing the category library
// itself) — the caller must include qa_category_id in `data` for add/update, and reorder
// is scoped to one category at a time since display_order only has meaning within a
// category's own tab (see ProductQuestionAnswerController::reorder on the backend).

export const getProductQuestionsAnswersApi = async (productId) => {
  const response = await API.get("product-questions-answers", { params: { product_id: productId } });
  return { response };
};

export const addProductQuestionAnswerApi = async (productId, data) => {
  const response = await API.post("product-questions-answers", { ...data, product_id: productId });
  return { response };
};

export const updateProductQuestionAnswerApi = async (id, productId, data) => {
  const response = await API.put(`product-questions-answers/${id}`, { ...data, product_id: productId });
  return { response };
};

export const deleteProductQuestionAnswerApi = async (id) => {
  const response = await API.delete(`product-questions-answers/${id}`);
  return { response };
};

export const reorderProductQuestionsAnswersApi = async (productId, qaCategoryId, orderedIdsOrPositions) => {
  // Same shape as reorderProductWearItTosApi: accepts either a plain array of ids (new
  // order implied by array position) or an array of already-built {id, display_order} pairs.
  const items = orderedIdsOrPositions.map((entry, index) =>
    entry && typeof entry === "object" ? { id: entry.id, display_order: entry.display_order } : { id: entry, display_order: index }
  );
  const response = await API.post("product-questions-answers/reorder", {
    product_id: productId,
    qa_category_id: qaCategoryId,
    items,
  });
  return { response };
};

export const getProductSustainabilityImagesApi = async (productId) => {
  const response = await API.get("product-sustainability-images", { params: { product_id: productId } });
  return { response };
};

export const uploadProductSustainabilityImageApi = async (productId, categoryId, file) => {
  const data = new FormData();
  data.append("product_id", productId);
  data.append("category_id", categoryId);
  data.append("image", file);
  const response = await API.post("product-sustainability-images", data);
  return { response };
};

export const deleteProductSustainabilityImageApi = async (id) => {
  const response = await API.delete(`product-sustainability-images/${id}`);
  return { response };
};

export const getProductReviewMediaApi = async (productId) => {
  const response = await API.get("product-review-media", { params: { product_id: productId } });
  return { response };
};

export const addProductReviewMediaApi = async (productId, file, displayOrder) => {
  const data = new FormData();
  data.append("product_id", productId);
  data.append("media_path", file);
  data.append("display_order", displayOrder ?? 0);
  const response = await API.post("product-review-media", data);
  return { response };
};

export const updateProductReviewMediaApi = async (id, productId, file, displayOrder) => {
  const data = new FormData();
  data.append("product_id", productId);
  if (file) data.append("media_path", file);
  data.append("display_order", displayOrder ?? 0);
  // Laravel doesn't parse multipart bodies on a real PUT — same _method-spoofing
  // convention as every other file-upload update in this codebase.
  data.append("_method", "PUT");
  const response = await API.post(`product-review-media/${id}`, data);
  return { response };
};

export const deleteProductReviewMediaApi = async (id) => {
  const response = await API.delete(`product-review-media/${id}`);
  return { response };
};

export const reorderProductReviewMediaApi = async (productId, orderedIdsOrPositions) => {
  const items = orderedIdsOrPositions.map((entry, index) =>
    entry && typeof entry === "object" ? { id: entry.id, display_order: entry.display_order } : { id: entry, display_order: index }
  );
  const response = await API.post("product-review-media/reorder", {
    product_id: productId,
    items,
  });
  return { response };
};

export const getProductPublicationsApi = async (id) => {
  const response = await API.get(`product/${id}/publications`);
  return { response };
};
